import React, { useState } from 'react';
import '../../styles/Auth/forgotPasswordPopUp.css';
import { postData } from "../../webService/webservice.js";
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaHouse } from 'react-icons/fa6';

const ForgotPasswordPopup = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // idle, success, error
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const handleSendLink = async () => {
        if (!email.includes('@')) {
            setStatus('error');
            setMessage('Please enter a valid email address.');
            return;
        }

        setIsLoading(true);
        setStatus('idle');
        setMessage('');

        try {
            const response = await postData('users/user/forgotpassword', { email });

            setStatus('success');
            setMessage(response.data.message || `A password reset link has been sent to ${email}`);
        } catch (error) {
            setStatus('error');
            const msg =
                error.response?.data?.message || 'Failed to send reset link. Please try again.';
            setMessage(msg);
        } finally {
            setIsLoading(false);
        }

    };
    return (
        <div className='forgot-password-bg'>
            <div className='forgot-password-container'>
                <div className='forgot-password-left'>
                    <img src="/assets/mayura-logo.png" alt="forgotpassword" />
                </div>

                <div className='forgot-password-right'>
                    <div className='forgot-password-form'>
                        <div className='forgot-password-logo'>
                            <img className='logo' src='/assets/mayura.png' alt='logo' />
                            <p className='forgot-password-title'>Reset Password</p>
                        </div>

                        {status === 'success' ? (
                            <>
                                <p style={{ color: 'white', fontSize: '14px', textAlign: 'center', marginBottom: '20px' }}>
                                    {message}
                                </p>
                                <div className="forgot-password-button">

                                    <button
                                        className="forgot-password-btn-main"
                                        onClick={() => navigate('/login')}
                                    >
                                        Return to Sign In
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className='forgot-password-input-group'>
                                    <FaEnvelope className='login-input-icon' />
                                    <input
                                        type="email"
                                        placeholder="Enter Your Email Id"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        className="forgot-password-input"
                                    />
                                </div>

                                {status === 'error' && (
                                    <p style={{ color: 'red', fontSize: '13px', marginBottom: '10px' }}>
                                        {message}
                                    </p>
                                )}

                                <div className='forgot-password-button'>
                                    <button
                                        className='forgot-password-btn-main'
                                        onClick={handleSendLink}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Sending...' : 'Send Reset Link'}
                                    </button>
                                </div>
                                <p
                                    className='forgot-password-link'
                                    onClick={() => navigate('/login')}
                                >
                                    <FaHouse size={18} /> Go to Sign In
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPopup;
